import * as React from 'react';
import { Modal, Button, BUTTON_TYPE } from '@bepure/tarkin';

interface State {
    open: boolean;
}

interface Props {
    imageUrl: string;
    name: string;
    price: string;
    editCartUrl: string;
    proceedUrl: string;
}

class AddedToCartModal extends React.PureComponent<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            open: true,
        };
    }

    public render() {
        return (
            <React.Fragment>
                {
                    this.state.open &&
                    (<div className="modal__background_cover" />)
                }
                <Modal open={this.state.open} handleClose={this.closeModal} contentClassName={'modal--white'}>
                    <div className="flex flex--column flex--align_center padding">
                        <p className="text text--body text--body--strong">
                            1 item was added to your cart.
                        </p>
                        <a href={this.props.editCartUrl} className="text text--link margin--small">
                            Edit cart
                        </a>
                        <img src={this.props.imageUrl} alt={`${this.props.name} box`} width="253px"/>
                        <h2 className="margin--small text text--heading text--heading--second text--center">
                            {this.props.name}
                        </h2>
                        <h3 className="margin--small text text--heading--2">
                            NZ ${this.props.price}
                        </h3>
                        <div className="flex flex--row flex--align_center flex--justify_center">
                            {/* <div
                                className="margin--small--top margin--large--left margin--large--right"
                            >
                                <Button
                                    text="Continue shopping"
                                    ariaLabel="continue shopping"
                                    button_type={BUTTON_TYPE.SECONDARY}
                                    onClick={this.handleContinueShopping}
                                />
                            </div> */}
                            <div
                                className="margin--small--top margin--large--left margin--large--right"
                            >
                                <Button
                                    id="view_cart_modal"
                                    text="View Cart"
                                    ariaLabel="view cart"
                                    button_type={BUTTON_TYPE.PRIMARY}
                                    onClick={this.handleProceed}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }

    private closeModal = () => {
        this.setState({
            open: false,
        });
    }

    // private handleContinueShopping = () => {
    //     this.closeModal();
    // }

    private handleProceed = () => {
        this.closeModal();
        window.location.href = this.props.proceedUrl;
    }

}

export default AddedToCartModal;
